<template>
	<v-sheet class="pa-4" rounded outlined>
		
		<!-- Encabezado -->
		<v-row dense>
			<v-expand-transition>
				<v-col cols="12" v-show="modoCalculadora">
					<v-sheet class="py-2 px-3 text-right text-h5" rounded outlined style="overflow-x:auto;">
						<span class="grey--text text--darken-3" style="white-space: nowrap;" 
							v-html="hayEntrada ? entrada : '&nbsp;'">
						</span>
					</v-sheet>
				</v-col>
			</v-expand-transition>
			<v-col cols="12">
				<v-sheet class="py-2 px-3 text-right text-h5" rounded outlined style="overflow-x:auto;">
					<span class="grey--text text--darken-3" style="white-space: nowrap;">
						{{ montoFormateado }}
					</span>
				</v-sheet>
			</v-col>
			<v-col cols="12" class="d-flex justify-end">
				<v-switch v-model="modoCalculadora" label="Calculadora" inset class="ma-0 pa-0" hide-details />
			</v-col>
		</v-row>
		
		<!-- Componente de botonera -->
		<v-row dense>
			<v-col>
				<component :is="botonera" @monto="botoneraMonto" @entrada="botoneraEntrada" 
					@exito="notificarExito" @alerta="notificarAlerta" @error="notificarError"
					:puedeEmitir="puedeEmitir" @emitir="botoneraEmitir" :cargando="cargando"
					:inhibir-teclado="inhibirTeclado"	
				/>
			</v-col>
		</v-row>
		
		<!-- Modal de emisión -->
 		<modal-boleta :visible="modalBoleta.visible" @cerrado="cerrarModalBoleta" @emitido="emitidoModalBoleta"
 			:monto="montoFinal" :datos-emisor="modalBoleta.datosEmisor" :monto-alerta="modalBoleta.montoAlerta"
			:config="modalBoleta.config.configuracionModalEmitir"	
		/>
 			
		<!-- Snackbar para notificaciones -->
		<v-snackbar v-model="notificacion.visible" bottom :color="notificacion.color" :timeout="15000">
			{{ notificacion.mensaje }}
			<v-btn dark text @click="notificacion.visible = false">
				Cerrar
			</v-btn>
		</v-snackbar>
		
		<!-- Diálogo alertas -->
		<v-dialog v-model="modalAlerta.visible" max-width="500" persistent>
			<v-card>
				<v-card-title class="text-h5 grey lighten-2">
					Alerta
				</v-card-title>
				<v-card-text v-if="!montoExcedePermitido" class="text-center text-subtitle-1">
					Está a punto de emitir una boleta por<br>
					<b>{{ montoFinalFormateado }}</b><br>
					<v-template v-if="montoFinalCero">
						Si está seguro, debe indicar en el detalle el motivo de esta boleta.<br>
					</v-template>
					¿Desea continuar?
				</v-card-text>
				<v-card-text v-else class="text-center text-subtitle-1">
					<b>No es posible emitir boletas con montos superiores a $1.000.000.000 (mil millones).</b>
					<br/>
					Por favor corrija el monto e inténtelo nuevamente.
				</v-card-text>
				<v-divider />
				<v-card-actions>
					<v-btn :block="montoExcedePermitido" color="error" :text="!montoExcedePermitido" 
						@click="cancelarModalAlerta" v-text="montoExcedePermitido?'Cancelar':'No'">
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn v-if="!montoExcedePermitido" color="success" depressed @click="aceptarModalAlerta">
						Sí
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
	</v-sheet>
</template>

<script>
import ModalBoleta from '@/components/Calculadora/ModalBoleta';
import BotoneraSimple from '@/components/Calculadora/BotoneraSimple';
import BotoneraExtendida from '@/components/Calculadora/BotoneraExtendida';
import * as AsyncExecUtils from '@/library/utils/async-exec';
import * as config from '@/config';
import asyncConfig, {actualizar} from '@/async-config';
import * as InfoContribuyente from '@/library/utils/info-contribuyente';
import {apiPingSistema} from '@/library/api/config';

// Manejadores de ejecución asíncrona
let emisorDataExitoExecutionManager = AsyncExecUtils.AsyncExecutionManager();
let emisorDataErrorExecutionManager = AsyncExecUtils.AsyncExecutionManager();

// Formateador números
let FORMATTERS = config.FORMATTERS;

export default {
	components: {
		ModalBoleta,
		BotoneraSimple,
		BotoneraExtendida,
	},
	props: {
		emisor: {
			type: Object,
			default: undefined,
		},
	},
	data () {
		return {
			// Modal boleta
			modalBoleta: {
				visible: false,
				datosEmisor: undefined,
				montoAlerta: undefined,
				cargando: false,
				config: {},
			},
			// Emisor
			cargandoDatosEmisor: false,
			// Configuración asíncrona
			cargandoMontoBoletaAlerta: false,
			// Notificación
			notificacion: {
				visible: false,
			},
			modalAlerta: {
				visible: false,
			},
			// Formateo números
			FORMATTERS,
			// Botonera
			modoCalculadora: false,
			entrada: undefined,
			monto: undefined, // Monto generado por botonera, no necesariamente monto final de boleta
			botonera: undefined,
			montoMaximoPosible: null,
		};
	},
	computed: {
		montoFinal: function() {
			// Monto FINAL por el que se hará la boleta
			let vm = this;
			// Ver si monto eso finito y su aproximación no negativa (mayor o igual que cero).
			// coberg 29-oct-2021, SII solicita poder emitir con monto $0.
			let monto = vm.monto;
			let esFinito = Number.isFinite(monto);
			if(!esFinito) {
				return undefined;
			}
			let aproximacion = Math.round(monto);
			let aproximacionEsNoNegativa = (aproximacion >= 0);
			if(!aproximacionEsNoNegativa) {
				return undefined;
			}
			return aproximacion;
		},
		montoFinalFormateado: function() {
			let vm = this;
			let montoFinal = vm.montoFinal;
			if(montoFinal === undefined) {
				return undefined;
			}
			return FORMATTERS.MONEY(montoFinal);
		},
		montoFormateado: function() {
			let vm = this;
			let monto = vm.monto;
			if(monto === undefined) {
				return FORMATTERS.MONEY(0);
			}
			return FORMATTERS.MONEY(monto);
		},
		inhibirTeclado: function() {
			let vm = this;
			// Colocar acá condiciones en que teclado de calculadora debe inhibirse.
			let inhibir = vm.modalBoleta.visible;
			return inhibir;
		},
		hayEntrada: function() {
			let vm = this;
			let entrada = vm.entrada;
			let hay = (entrada !== undefined) && (entrada !== '');
			return hay;
		},
		hayMontoFinal: function() {
			let vm = this;
			let montoFinal = vm.montoFinal;
			let hay = (montoFinal !== undefined);
			return hay;
		},
		cargando: function() {
			let vm = this;
			let actividad = [
				vm.cargandoDatosEmisor,
				vm.cargandoMontoBoletaAlerta,
			];
			let cargando = actividad.reduce((x,y) => (x || y), false);
			return cargando;
		},
		puedeEmitir: function() {
			let vm = this;
			let puede = (vm.hayEmisor && vm.hayMontoFinal);
			return puede;
		},
		hayEmisor: function() {
			let vm = this;
			let emisor = vm.emisor;
			let hay = (emisor !== undefined);
			return hay;
		},
		montoExcedePermitido: function() {
			let vm = this;
			let montoFinal = (vm.montoFinal || 0);
			return (montoFinal >= vm.montoMaximoPosible);
		},
		montoFinalCero : function() {
			let vm = this;
			return (vm.montoFinal === 0);
		},
	},
	methods: {
		reiniciar: function() {
			let vm = this;
			// Botoneras emiten monto y entrada iniciales al montarse
			vm.botonera = undefined;
			vm.$nextTick(() => { vm.botonera = vm.modoCalculadora ? BotoneraExtendida : BotoneraSimple; });
		},
		//////////////////////////////
		// Eventos botonera
		botoneraMonto: function(monto) {
			let vm = this;
			vm.monto = monto;
		},
		botoneraEntrada: function(entrada) {
			let vm = this;
			vm.entrada = entrada;
		},
		botoneraEmitir: function() {
			let vm = this;
			vm.emitir();
		},
		//////////////////////////////
		// Modal boleta
		emitir: async function() {
			let vm = this;
			vm.cargandoMontoBoletaAlerta = true;
			vm.modalBoleta.config = await actualizar();
			
			vm.modalBoleta.montoAlerta = vm.modalBoleta.config.montoBoletaAlerta;
			
			vm.cargandoMontoBoletaAlerta = false;

			let montoAlerta = vm.modalBoleta.montoAlerta;
			let montoBoleta = vm.monto;
			let hayMontoAlerta = (montoAlerta !== undefined);
			let montoBoletaIgualMayorMontoAlerta = (montoBoleta >= montoAlerta);
			// Abrir modal

			// coberg 29-oct-2021, SII solicita poder emitir con monto $0 y debe mostrarse advertencia
			let montoEsCero = (vm.montoFinal === 0);

			//22-feb-2022, SII solicita detalle en boletas con monto $0
			let mostrarAlerta = (hayMontoAlerta && montoBoletaIgualMayorMontoAlerta) || montoEsCero;
			
			if(mostrarAlerta) {
				// Mostrar modal alerta
				vm.mostrarModalAlerta();
			}
			else {
				vm.abrirModalBoleta();
			}
		},
		abrirModalBoleta: async function() {
			let vm = this;
			vm.modalBoleta.cargando = true;
			vm.modalBoleta.cargando = false;
			vm.modalBoleta.visible = true;
		},
		cerrarModalBoleta: function() {
			let vm = this;
			vm.modalBoleta.visible = false;
		},
		emitidoModalBoleta: function() {
			let vm = this;
			vm.reiniciar();
		},
		
		//////////////////////////////
		// Datos emisor
		cargarDatosEmisor: function(rutSinDvContribuyente) {
			let vm = this;
			vm.cargandoDatosEmisor = true;
			vm.modalBoleta.datosEmisor = undefined;
			vm.reiniciar(); // Limpiar calculadora y obtener datos
			
			let exito = function(data) {
				vm.modalBoleta.datosEmisor = data;
				vm.cargandoDatosEmisor = false;
			};
			let error = function(/*err*/) {
				vm.cargandoDatosEmisor = false;
				vm.notificarError(`Hubo un error al obtener datos de emisor`);
			};

			let emisorDataExitoExecutor = emisorDataExitoExecutionManager.getExecutor(exito);
			let emisorDataErrorExecutor = emisorDataErrorExecutionManager.getExecutor(error);
			
			let usuario = vm.$store.getters['usuario/usuario'];
			
			InfoContribuyente.infoEmisorUsuario(rutSinDvContribuyente, usuario,
				function(res){ 
					emisorDataErrorExecutionManager.inhibitExecution(); 
					emisorDataExitoExecutor.attemptExecution(res.data); 
				}, 
				function(err){ 
					emisorDataExitoExecutionManager.inhibitExecution(); 
					emisorDataErrorExecutor.attemptExecution(err);
			});
		},
		
		//////////////////////////////
		// Notificaciones
		notificarAlerta: function(mensaje) {
			let vm = this;
			vm.notificar(mensaje, 'warning');
		},
		notificarError: function(mensaje) {
			let vm = this;
			vm.notificar(mensaje, 'error');
		},
		notificarExito: function(mensaje) {
			let vm = this;
			vm.notificar(mensaje, 'success');
		},
		notificar: function(mensaje, color) {
			let vm = this;
			vm.notificacion.mensaje = mensaje;
			vm.notificacion.color = color;
			vm.notificacion.visible = true;
		},
		mostrarModalAlerta: function() {
			let vm = this;
			vm.modalAlerta.visible = true;
			
		},
		cancelarModalAlerta: function() {
			let vm = this;
			vm.modalAlerta.visible = false;
		},
		aceptarModalAlerta: async function() {
			let vm = this;
			vm.modalAlerta.visible = false;
			vm.abrirModalBoleta();
		}
	},
	watch: {
		emisor: function(nuevoEmisor) {
			let vm = this;
			// Cargar datos de nuevo emisor seleccionado
			if( !nuevoEmisor ) return;
			let rutSinDv = nuevoEmisor.rut;
			vm.cargarDatosEmisor(rutSinDv);
		},
		modoCalculadora: function() {
			let vm = this;
			vm.reiniciar();
		}
	},
	mounted: function() {
		let vm = this;
		// Cargar datos de emisor seleccionado, si lo hay
		let emisor = vm.emisor;
		if(emisor !== undefined) {
			let rutSinDv = emisor.rut;
			vm.cargarDatosEmisor(rutSinDv);
		}
		// Conectar teclado
		window.addEventListener('keydown', vm.listenerTeclado);
		asyncConfig.montoMaximoBoleta.then(monto=>{
			vm.montoMaximoPosible = monto
		}).catch(e=>{ vm.montoMaximoPosible = 1000000000})
	},
	beforeDestroy: function() {
		let vm = this;
		// Desconectar teclado
		window.removeEventListener('keydown', vm.listenerTeclado);
	},
	created: function() {
	},
};
</script>

